export default function ChatDisclaimer() {
  return (
    <div
      className="shrink-0 text-center text-[12px] font-normal leading-[150%] text-[var(--chat-grey-500)] px-[16px] sm:px-[var(--chat-space-06)]"
      style={{ fontFamily: "Inter" }}
    >
      <p className="mb-0">
        This chat is powered by AI and may provide general health information,
        but it does not provide medical advice.
      </p>
      <p className="mb-0">
        <a
          href="https://www.evvy.com/terms-of-service"
          target="_blank"
          rel="noopener noreferrer"
          className="underline"
        >
          Terms of Service
        </a>
        <span>{`  |   `}</span>
        <a
          href="https://www.evvy.com/privacy-policy"
          target="_blank"
          rel="noopener noreferrer"
          className="underline"
        >
          Privacy Policy
        </a>
      </p>
    </div>
  );
}
